export class MensajeArchivosNotificacionesDTO {
  numeroDestino: string;
  numeroOrigen: string;
  mensage: string;
  adjuntoBase64: string;
  nombreArchivo: string;
  mimeType: string;  
  nroByte: number;
  urlArchivo: string;
}